import React from 'react';

class PinIcon extends React.Component {
  render() {
    return (
      <svg
        width="20"
        height="30"
        viewBox="0 0 20 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10V10.2348C20 11.9285 19.5797 13.5958 18.7766 15.0871L11.1006 29.3426C10.8826 29.7475 10.4599 30 10 30C9.54015 30 9.11743 29.7475 8.89941 29.3426L1.22335 15.0871C0.420347 13.5958 0 11.9285 0 10.2348V10ZM10 2.5C5.85786 2.5 2.5 5.85786 2.5 10V10.2348C2.5 11.5148 2.81767 12.7748 3.42453 13.9018L10 26.1134L16.5755 13.9018C17.1823 12.7748 17.5 11.5148 17.5 10.2348V10C17.5 5.85786 14.1421 2.5 10 2.5ZM10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z"
          fill="#8A8B8D"
        />
      </svg>
    );
  }
}

export default PinIcon;
